<span style="font-size: 1.2em; font-weight: bold;" class="d-block">{{ step2.getspan2 | translate }}</span>
<br />

<app-typeCPV-class [uid]="getUid()" [displayStar]="true" [parentForm]="parentForm" [objetPrincipal]="cpv.objetPrincipal" [disabled]="disabled" (preferenceSelected)="chargeDonneePreference($event)">
</app-typeCPV-class>

<span class="d-block">{{ step2.getspan3  | translate }}</span>

<button class="btn btn-outline-primary" (click)="addtypeCPVClass()">Ajouter</button>
  <div *ngFor="let obj of cpv.objetComplementaire| slice:0:4; let i = index">
<button class="btn btn-outline-primary" (click)="removetypeCPVClass(i)">Supprimer</button>

<app-typeCPV-class [uid]="getUid()+'_index_'+(i+1)" [parentForm]="parentForm" [displayStar]="false" [objetPrincipal]="obj" [disabled]="disabled"></app-typeCPV-class>
  </div>
